<template lang="pug">
    div
        div.dataPackage
            div.dataPackageContent
                div.contentTitle {{ item.name }}
                div.contentDescription {{ item.description }}
                table
                    tr
                        td Pay period:
                        td {{ item.pay_period }}

                    tr
                        td Paid until:
                        td {{ paidUntil }}

                    tr
                        td Trial end:
                        td {{ trialEnd }}

            div(v-if="item.monthly_price != '___'")
                v-radio-group.dataPackageOptions(v-model="packageType" @change="updatePackage")
                    div.dataPackageOptions
                        div.monthlyOption
                            div.optionTitle {{ $t('payments.options.monthly.title') }}
                            div.optionPrice {{ `$${item.monthly_price}` }}
                            v-radio(:value="item.monthly_stripe_id")

                        div.quarterlyOption
                            div.optionTitle {{ $t('payments.options.quarterly.title') }}
                            div.optionPrice {{ `$${item.quarterly_price}` }}
                            v-radio(:value="item.quarterly_stripe_id")

                        div.annualOption
                            div.optionTitle {{ $t('payments.options.annual.title') }}
                            div.optionPrice {{ `$${item.annual_price}` }}
                            v-radio(:value="item.annual_stripe_id")

        v-divider.my-2
</template>

<script>
    import VueTypes from 'vue-types';
    import { mapActions } from 'vuex';
    import dayjs from 'dayjs';

    export default {
        props: {
            item: VueTypes.object.def({}),
            subscribeCallback: VueTypes.func.def(() => {}),
            savedCard: VueTypes.object.def({}),
        },
        data() {
            return {
                packageType: this.item.subscribed,
            };
        },
        computed: {
            paidUntil() {
                return dayjs(this.item.paid_until).format('MM/DD/YYYY');
            },
            trialEnd() {
                return dayjs(this.item.trial_end).format('MM/DD/YYYY');
            },
        },
        methods: {
            ...mapActions('snackbar', ['showMessage']),

            async updatePackage() {
                if (
                    !this.savedCard ||
                    !(this.savedCard && Object.keys(this.savedCard).length)
                )
                    return this.showMessage(
                        'Please add a card before subscribing'
                    );

                const data = new FormData();
                data.append('product_id', this.item.product_stripe_id);
                data.append('price_id', this.packageType);

                this.subscribeCallback(data);
            },
        },
    };
</script>

<style lang="stylus" scoped>
    @import '../../assets/style/_variables.styl'

    .dataPackage
    .dataPackageOptions
        display: flex
        align-items: center
        justify-content: space-between

    .dataPackage > div
        flex: 1 1 50%

    .dataPackageContent
        lex: 1 1 50%

    .contentTitle
        font-weight: 700
        text-transform: uppercase

    .dataPackageOptions > div
        display: flex
        align-items: center
        flex-direction: column

    .optionTitle
        text-transform: uppercase

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .dataPackage
            flex-direction: column
</style>
